module.exports = __webpack_public_path__ + "static/media/SY_dummies_23.f3a8566b.jpg";